import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Building2,
  CalendarClock,
  FileText,
  Image as ImageIcon,
  Mail,
  Newspaper,
} from "lucide-react";
import { adminApi } from "./api";

const CARDS = [
  { key: "hotels", label: "Hotel", icon: Building2, to: "/admin/hotels" },
  {
    key: "openings",
    label: "Nuove Aperture",
    icon: CalendarClock,
    to: "/admin/openings",
  },
  { key: "news", label: "Articoli News", icon: Newspaper, to: "/admin/news" },
  {
    key: "messages",
    label: "Messaggi ricevuti",
    icon: Mail,
    to: "/admin/messages",
  },
  {
    key: "documents",
    label: "Documenti riservati",
    icon: FileText,
    to: "/admin/documents",
  },
  {
    key: "media",
    label: "Media caricati",
    icon: ImageIcon,
    to: "/admin/media",
  },
];

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    adminApi.get("/admin/stats").then((r) => setStats(r.data));
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#C48F56]">
        Overview
      </div>
      <h1 className="mt-2 font-display font-light text-5xl md:text-6xl tracking-tightest">
        Buongiorno.
      </h1>
      <p className="mt-4 text-white/60 max-w-xl">
        Gestisci contenuti, immagini e richieste. Ogni modifica è pubblicata in
        tempo reale sul sito pubblico.
      </p>

      <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {CARDS.map((c) => (
          <Link
            key={c.key}
            to={c.to}
            data-testid={`dashboard-card-${c.key}`}
            className="group rounded-2xl border border-white/10 bg-[#0F0F14] p-6 hover:border-white/25 transition-colors"
          >
            <div className="flex items-center justify-between">
              <div className="h-10 w-10 rounded-full bg-white/5 grid place-items-center text-[#C48F56]">
                <c.icon size={16} />
              </div>
              <span className="text-white/30 text-xs uppercase tracking-[0.2em]">
                Gestisci →
              </span>
            </div>
            <div className="mt-6 font-display text-5xl tracking-tight">
              {stats ? (stats[c.key] ?? 0) : "—"}
            </div>
            <div className="mt-1 text-sm text-white/60">{c.label}</div>
            {c.key === "messages" && stats?.unread_messages > 0 && (
              <div className="mt-2 inline-flex items-center gap-1 text-xs text-[#C48F56]">
                • {stats.unread_messages} non letti
              </div>
            )}
          </Link>
        ))}
      </div>
    </div>
  );
}
